module.exports = __webpack_public_path__ + "img/creativeDNA.93c36f18.svg";